import React from 'react'

import { Flex, P } from 'ui/bend'
import SubmitButton from './SubmitButton'
import { useActiveMembershipContext } from '../../../ActiveMembershipStore'

const PaymentMethods = () => {
  const { paymentMethods } = useActiveMembershipContext()
  return (
    <Flex flexDirection='column' padding='15px'>
      {paymentMethods && paymentMethods.length > 0 ? (
        <>
          <P variant='bold'>Your current payment method</P>
          <P>{paymentMethods[0].cardName}</P>
          {paymentMethods.length > 1 && (
            <>
              <P variant='bold'>Other payment methods</P>
              {paymentMethods.slice(1).map((card) => (
                <P key={card.id}>{card.cardName}</P>
              ))}
            </>
          )}
          <P>
            Changing your payment method will apply to your next scheduled
            payment. Your membership will remain the same.
          </P>
        </>
      ) : (
        <P>
          We cannot retrieve your payment methods at this time. Your account may
          be updating.
        </P>
      )}
      <SubmitButton />
    </Flex>
  )
}

export default PaymentMethods
